import type { SimpleKeyboard } from 'react-simple-keyboard';
import { SPECIAL_KEYS } from '../utils/constants';
import { CandidateMethods, KeyboardModule } from 'components/Keyboard/types';

type LiteralKeyboard = SimpleKeyboard & Partial<CandidateMethods>;

// Function-key tokens (braces) that should simply type a literal string. react-simple-keyboard
// only appends text for its built-in tokens ({space}, {bksp}, {enter}...) and plain characters,
// so any custom `{token}` needs an entry here to be typed.
// To add a new literal key: add its token → text mapping below (nothing else to wire).
const LITERAL_BY_KEY: Partial<Record<string, string>> = {
  [SPECIAL_KEYS.AT]: '@',
};

function literalKeys(keyboard: LiteralKeyboard) {
  keyboard.registerModule('literalKeys', (module: KeyboardModule) => {
    module.fn = { handleButtonClicked: keyboard.handleButtonClicked };

    keyboard.handleButtonClicked = (...args) => {
      const [button] = args;
      const literal = LITERAL_BY_KEY[button];
      if (literal !== undefined) {
        keyboard.flushCandidates?.();
        const input = `${keyboard.getInput()}${literal}`;
        keyboard.setInput(input);
        keyboard.setCaretPosition(input.length);
        keyboard.options.onChange?.(input);
        return;
      }
      return module.fn.handleButtonClicked.call(keyboard, ...args);
    };
  });
}

export default literalKeys;
